
export const OpcionesDeNivelDeIngles = [
    {
        key: 'Basico',
        text: 'Basico',
        value: 'Basico',
        valueToSend : 1
    },
    {
        key: 'Intermedio',
        text: 'Intermedio',
        value: 'Intermedio',
        valueToSend : 2
    },
    {
        key: 'Avanzado',
        text: 'Avanzado',
        value: 'Avanzado',
        valueToSend : 3
    }
];
